'use client';

import { useQuery } from '@tanstack/react-query';
import { getInputOptionsAction } from '@/dal/jobs/actions';

export function useInputOptions(key: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: ['input-options', key],
    queryFn: () => getInputOptionsAction(key),
  });

  return {
    options: data || [],
    isLoading,
    error,
  };
}
